// extracted by mini-css-extract-plugin
export var button = "_96-0";
export var icon = "_96-1";